module.exports = __webpack_public_path__ + "static/portrait-8425aff4aece4a6a605a06d95c0a0ffc.png";